import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useBlogSettings } from "@/context/BlogContext";
import { blogPostPath, blogListPath } from "@/lib/blog";

/**
 * Detay sayfasında bu yazının diğer dillerdeki çevirilerine link verir.
 * Çeviri yoksa o dilin butonunu ana blog listesine yönlendirir.
 *
 * `translations` API'den gelir: [{language, slug, is_published}, ...]
 *
 * Multilang KAPALI iken hiç render etme.
 */
const langLabels = { tr: "TR", en: "EN", ar: "AR" };
const langFlags = { tr: "🇹🇷", en: "🇬🇧", ar: "🇸🇦" };

export function PostLanguageSwitcher({ translations = [], currentLang }) {
  const { lang: uiLang } = useLanguage();
  const settings = useBlogSettings();

  if (!settings.multilang_enabled) return null;
  if (settings.enabled_languages.length <= 1) return null;

  const byLang = Object.fromEntries(translations.filter((t) => t.is_published).map((t) => [t.language, t]));
  const active = currentLang || uiLang;

  return (
    <div className="inline-flex items-center gap-1 p-1 rounded-full border border-slate-200 bg-white text-xs">
      <Globe className="w-3.5 h-3.5 text-slate-400 ml-2" />
      {settings.enabled_languages.map((code) => {
        const tr = byLang[code];
        const isActive = code === active;
        const target = tr ? blogPostPath(code, tr.slug) : blogListPath(code);
        const disabled = !tr;
        return (
          <Link
            key={code}
            to={target}
            className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full transition-colors ${
              isActive
                ? "bg-sky-50 text-[#22A7D1] font-bold"
                : disabled
                ? "text-slate-300 cursor-not-allowed"
                : "text-slate-600 hover:bg-slate-50"
            }`}
            onClick={(e) => disabled && e.preventDefault()}
            title={disabled ? "—" : ""}
          >
            <span>{langFlags[code]}</span>
            <span>{langLabels[code]}</span>
          </Link>
        );
      })}
    </div>
  );
}
